import { SkpIcon } from '@skeepers/skeepers-ui-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import style from './style.module.css';

const RoundedButton = ({ icon = null, disabled = false, backgroundColor = '', iconColor = 'white', className = '', onClick = () => {}, label = null }) => {
  return (
    <span
      className={classNames(style.root, disabled ? style.disabled : null, className)}
      style={{ backgroundColor: backgroundColor }}
      onClick={() => disabled ? null : onClick()}
    >
      <SkpIcon icon={icon} color={iconColor} skpTitle={label}/>
    </span>
  );
};

export default RoundedButton;

RoundedButton.propTypes = {
  type: PropTypes.string,
  backgroundColor: PropTypes.string,
  disabled: PropTypes.bool,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};
